export function FilterSubmit() {
  return (
    <button className="rounded-md border-2 border-gray-300 bg-white px-4 py-2 hover:border-yellow-400">
      <input type="submit" value="FILTER" />
    </button>
  );
}
